import { Divider, HStack, Text } from '@chakra-ui/react';

/** "or" between a step's drop zone and its other ways in. */
export function OrDivider() {
  return (
    <HStack spacing={3} py={1} aria-hidden="true">
      <Divider borderColor="border.default" />
      <Text
        fontFamily="mono"
        fontSize="2xs"
        letterSpacing="0.08em"
        textTransform="uppercase"
        color="text.secondary"
      >
        or
      </Text>
      <Divider borderColor="border.default" />
    </HStack>
  );
}
